import React, { useContext, useEffect } from 'react';
import LoadingIcon from '../../components/loading/loading-icon';
import InfiniteScroll from 'react-infinite-scroller';
import PostRow from '../../components/posts/post-row';
import PostItem from '../../components/posts/post-item';
import { Context } from '../../../context/global-data-provider';
import { PostsListContext } from '../../../context/category-posts-list-provider';
import './posts-list-style.css';

function CategoryPostsList() {
  const [provider] = useContext(PostsListContext);
  const { options } = useContext(Context);

  useEffect(() => {
    document.title = options.title + ' • ' + provider.category.title;
  }, [provider.category]);

  function loadMore(pn) {
    provider.loadPosts(provider.category.id, pn);
  }

  let i_s_setting = {
    pageStart: provider.pageNumber,
    loadMore: loadMore,
    hasMore: provider.hasMore,
    useWindow: true,
    loader: <LoadingIcon className={'post-loading'} width={32} height={32} fill={'#555555'} key={0} />,
  };

  if (provider.postLoaded) {
    return (
      <div className="posts-list">
        <article className="f-grow-1">
          <InfiniteScroll {...i_s_setting}>
            {provider.posts.map((row, i) => {
              return (
                <PostRow key={i}>
                  {row.map((post, j) => {
                    return <PostItem data={post} key={j} />;
                  })}
                </PostRow>
              );
            })}
          </InfiniteScroll>
        </article>
      </div>
    );
  } else {
    return (
      <div className="posts-list">
        <LoadingIcon className={'post-loading'} width={32} height={32} fill={'#555555'} key={0} />
      </div>
    );
  }
}

export default CategoryPostsList;
